module.exports = __webpack_public_path__ + "img/riders_inactive.d888fe7b.svg";